import { IExercise } from '~/models/Exercise';

export const orderTrainingsByName = (a: IExercise, b: IExercise) => {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
};
